import { Action } from "redux";

export type ReviztoIssueCreationDialogDismissedEvent = Action<typeof REVIZTO_ISSUE_CREATION_DIALOG_DISMISSED>

const reviztoIssueCreationDialogDismissedEvent = (): ReviztoIssueCreationDialogDismissedEvent => ({
  type: REVIZTO_ISSUE_CREATION_DIALOG_DISMISSED
});

export const REVIZTO_ISSUE_CREATION_DIALOG_DISMISSED = "revizto_issue_creation_dialog_dismissed";

export default reviztoIssueCreationDialogDismissedEvent;